// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Dashboard: React.LazyExoticComponent<any> = React.lazy(() => import('../components/Dashboard'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        title: 'GeoTracking Dashboard',
        active: true,
        component: Dashboard,
        props: {
          report: 'DASHBOARD_GTRACKING',
          title: 'GeoTracking Dashboard',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
